import React, { createContext, useContext, useCallback } from 'react';
import { recordAdminAnalyticsEvent } from './services/supabaseAnalytics';
import { parseBrowser, parseDevice } from './catalog/components/services/analyticsUtils';

type TrackEventOptions = {
  eventType: string;
  page?: string;
  label?: string;
  metadata?: Record<string, unknown>;
};

type AnalyticsContextValue = {
  track: (opts: TrackEventOptions) => void;
};

const AnalyticsContext = createContext<AnalyticsContextValue>({
  track: () => {}
});

export const useAnalytics = () => useContext(AnalyticsContext);

export const AnalyticsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const track = useCallback((opts: TrackEventOptions) => {
    recordAdminAnalyticsEvent({
      eventType: opts.eventType,
      page: opts.page,
      label: opts.label,
      metadata: {
        browser: parseBrowser(navigator.userAgent),
        device: parseDevice(navigator.userAgent),
        referrer: document.referrer || 'Direct',
        ...opts.metadata
      }
    });
  }, []);

  return (
    <AnalyticsContext.Provider value={{ track }}>
      {children}
    </AnalyticsContext.Provider>
  );
};
